// extracted by mini-css-extract-plugin
export default {"container":"VoiceLanguageListCell_container__Ax4Kh","languageText":"VoiceLanguageListCell_languageText__xmJsT"};